import { Box, Flex } from '@chakra-ui/react';
import { useLingui } from '@lingui/react/macro';

import { SessionLiveBadge } from '#modules/finder/features/posts/components/SessionParts';
import { TimeLeft } from '#modules/finder/features/posts/components/Timer';
import { formatStartsIn, useRoomClock, type SessionRoomPhase } from './RoomChrome';

/** Фаза сессии названа словами, независимо от личного подключения к голосу. */
export const RoomPhaseLabel = ({
  phase,
  startedAt,
  expiredAt,
  compact = false,
}: {
  phase: SessionRoomPhase;
  startedAt?: string | null;
  expiredAt?: string | null;
  compact?: boolean;
}) => {
  const { t } = useLingui();
  const now = useRoomClock(phase);
  const startsIn = phase === 'upcoming' ? formatStartsIn(startedAt, now) : null;
  const label =
    phase === 'cancelled'
      ? compact
        ? t`Session cancelled`
        : t`post:session.room.cancelledHint`
      : phase === 'ended'
        ? compact
          ? t`post:session.room.phaseEnded`
          : t`post:session.room.phaseEndedChatRemains`
        : startsIn
          ? t`post:session.room.phaseStartsIn ${startsIn}`
          : null;

  return (
    <Flex
      align="center"
      flexWrap="wrap"
      columnGap={1}
      textStyle="caption"
      whiteSpace={compact ? 'nowrap' : undefined}
      aria-live={phase === 'upcoming' ? 'off' : 'polite'}
    >
      <Box color={phase === 'live' ? 'status.live.fg' : 'fg.secondary'}>
        {phase === 'live' ? <SessionLiveBadge /> : label}
      </Box>
      {!compact && phase === 'live' && expiredAt ? (
        <Box
          as="span"
          color="fg.success"
          fontVariantNumeric="tabular-nums"
          textStyle="label"
          aria-live="off"
        >
          <TimeLeft time={expiredAt} />
        </Box>
      ) : null}
    </Flex>
  );
};
